import { render, staticRenderFns } from "./ChatRobot.vue?vue&type=template&id=fca66bbc"
import script from "./ChatRobot.vue?vue&type=script&lang=js"
export * from "./ChatRobot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports